import axios from "axios";
import { zoop } from "../config/ZoopConfig";
import { getToken } from "./Auth";

export const Api = axios.create({
   baseURL: "https://api.paguedireto.com.br",
  // baseURL: "http://localhost:9104",
  // baseURL: "http://192.168.101.32:9104",
//   baseURL: "https://3ad2-2804-d4b-8902-300-684e-9c6b-5bc2-9e84.sa.ngrok.io/",
  timeout: "50000",
});

Api.interceptors.request.use(async config => {
    const token = getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    
    return config;
    });

export const ApiZoop = axios.create({
        baseURL: "https://api.zoop.ws",
        timeout: 50000,
      });
      
ApiZoop.interceptors.request.use(async (config) => {
    const token = zoop.ZOOP_TOKEN;
    if (token) {
        config.headers.Authorization = `Basic ${token}`;
    }
    return config;
    });

      